// extract gametables/xp.txt
export const experiencePerLevel = [
    0,
    250,
    655,
    1245,
    2025,
    2995,
    4155,
    5505,
    7040,
    8770,
    10590, // 10
    11685,
    12795,
    13920,
    15055,
    16210,
    17380,
    18560,
    19755,
    20970,
    22195, // 20
    23435,
    24690,
    25960,
    27245,
    28545,
    29860,
    31190,
    32535,
    33890,
    32075, // 30
    32700,
    33295,
    33865,
    34410,
    34925,
    35415,
    35875,
    36310,
    36720,
    37100, // 40
    37450,
    37780,
    38075,
    38350,
    38595,
    38810,
    39000,
    39165,
    39300,
    40435, // 50
    41590,
    42750,
    43930,
    45120,
    46325,
    47545,
    48775,
    50020,
    51280,
    52555, // 60
    53840,
    55140,
    56455,
    57780,
    59120,
    60475,
    61845,
    63225,
    64620,
    58645, // 70
    60335,
    62045,
    63780,
    65540,
    67325,
    69130,
    70965,
    72820,
    74700,
    403725, // 80
    423390,
    443395,
    463740,
    484430,
    505455,
    526825,
    548535,
    570590,
    592980,
    0, // 90
];
